var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('parent-layout',{attrs:{"title":"District Instances"}},[_c('client-instance-list',{attrs:{"client-id":_vm.getIlluminateClientId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }